<template>
  <div>
    <v-data-table
      v-if="caseManagers"
      :headers="tableHeaders"
      :items="actionsLog"
      no-data-text="No actions"
      hide-actions
      disable-initial-sort
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.action }}</td>
        <td>{{ props.item.username }}</td>
        <td>
          <v-flex v-if="props.item.payload && props.item.payload === 'null'"></v-flex>
          <v-expansion-panel v-else="props.item.payload">
            <v-expansion-panel-content>
              <v-flex slot="header">show</v-flex>
              <v-card>
                <v-card-text class="grey lighten-3" v-html="parsedPayload(props.item.payload)"></v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </td>
        <td>{{ props.item.created_at }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    computed: {
      ...mapGetters({
        products: 'allProducts',
        services: 'allServices',
        serviceById: 'getServiceById',
        caseManagerById: 'getCaseManagerById',
        actionsLog: 'caseLog',
        caseManagers: 'caseManagers'
      }),
      parsePayload (item) {

      }
    },
    data () {
      return {
        tableHeaders: [
          { text: 'Action', value: 'action' },
          { text: 'Username', value: 'username' },
          { text: 'Payload', value: 'payload' },
          { text: 'Date', value: 'created_at' }
        ]
      }
    },
    props: {
      casesid: {
        type: Number,
        required: true
      }
    },
    methods: {
      parsedPayload (item) {
        if (!item) return 'N/A'
        let after = undefined !== Object.keys(item)[0] ? Object.keys(item)[0] : false
        let before = undefined !== Object.keys(item)[1] ? Object.keys(item)[1] : false
        let log = ''
        if (item.commissions) log += 'Commission set: ' + item.commissions
        if (item.deposit) log += 'Deposit: ' + item.deposit
        if (item.casecrew_id) log += 'Case Crew Selected: ' + this.getCaseCrewNameById(item.casecrew_id)
        if (before) {
          if (before === 'old_services') {
            if (item[before].length > 0 && undefined !== _.map(item[before], 'name').join(', ')) log += 'Before: ' + _.map(item[before], 'name').join(', ')
            else log += 'Not set'
          }
          if (before === 'services_id') log += 'Before: ' + undefined !== this.serviceById(item[before]) ? this.serviceById(item[before]).name : item[before].length + '(N/A)'
          if (before === 'old_manager' && item[before] !== null) {
            log += 'Old manager: ' + this.caseManagerById(item[before]) && this.caseManagerById(item[before]).email !== undefined ? this.caseManagerById(item[before]).email : this.caseManagerById(item[before]).name
          }
          log += '<br>'
        }
        if (after) {
          if (after === 'services' && item[after].length > 0) {
            let res = 'After: ' + _.map(item[before], 'name').join(', ')
            if (!res) {
              res = 'After: ' + item[after].reduce((acc, service) => this.serviceById(service.service_id).name + ' ' + service.amount + '<br>')
            }
            log += res
          }
          if (after === 'services_id') {
            log += 'After: '
            log += item[after].length > 0 ? item[after].length + '(N/A)' : (undefined !== this.serviceById(item[after])) ? this.serviceById(item[after]).name : '1 (N/A)'
          }
          if (after === 'new_manager') log += 'New manager: ' + this.caseManagerById(item[after]) !== undefined ? this.caseManagerById(item[after]).email : ''
        }
        return log
      },
      getCaseCrewNameById (id) {
        return this.services.find(i => i.id === id).name
      }
    },
    beforeCreate () {
      // this.$store.dispatch('getAllPlans')
      // this.$store.dispatch('getAllProducts')
      // this.$store.dispatch('getCaseManagers')
    },
    created () {
      this.$store.dispatch('getCaseLog', this.casesid)
    }
  }
</script>



// WEBPACK FOOTER //
// CaseActionsLogDataTable.vue?424729cb